import { render, staticRenderFns } from "./sendBtn.vue?vue&type=template&id=3f34064c&scoped=true&"
import script from "./sendBtn.vue?vue&type=script&lang=js&"
export * from "./sendBtn.vue?vue&type=script&lang=js&"
import style0 from "./sendBtn.vue?vue&type=style&index=0&id=3f34064c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f34064c",
  null
  
)

export default component.exports